import List from "./Composer";

List.install = function(Vue) {
  Vue.component(List.name, List);
};

export default List;
